"use client";

import { useEffect, useRef, useState, type ChangeEvent, type HTMLAttributes } from "react";
import { cn } from "~/lib/utils";

interface SearchboxProps extends HTMLAttributes<HTMLInputElement> {
  handleSearch: (_: string) => void;
  className?: string;
}

const search_input_style =
  "focus:border-primary mt-10 flex flex-row gap-3 rounded-2xl border-2 border-gray-600 px-3 py-2.5";

export default function SearchBoxRoot({
  className,
  handleSearch,
  ...props
}: SearchboxProps) {
  const [searchTerm, setSearchTerm] = useState<string>("");
  const debounceTimer = useRef<NodeJS.Timeout | null>(null);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchTerm(value);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      handleSearch(value);
    }, 500);
  };

  useEffect(() => {
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, []);

  return (
    <div className={cn(search_input_style, className)}>
      <SearchIcon />
      <input
        {...props}
        type="search"
        className="text-md flex-1 bg-transparent focus:outline-none"
        placeholder="جستجو"
        onChange={handleChange}
        value={searchTerm}
      />
    </div>
  );
}

const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2109 2.75C7.37845 2.75 3.46094 6.66751 3.46094 11.5C3.46094 16.3325 7.37845 20.25 12.2109 20.25C17.0434 20.25 20.9609 16.3325 20.9609 11.5C20.9609 6.66751 17.0434 2.75 12.2109 2.75ZM1.96094 11.5C1.96094 5.83908 6.55002 1.25 12.2109 1.25C17.8719 1.25 22.4609 5.83908 22.4609 11.5C22.4609 14.0605 21.5221 16.4017 19.9698 18.1982L23.2413 21.4697C23.5342 21.7626 23.5342 22.2374 23.2413 22.5303C22.9484 22.8232 22.4735 22.8232 22.1806 22.5303L18.9091 19.2589C17.1127 20.8111 14.7715 21.75 12.2109 21.75C6.55002 21.75 1.96094 17.1609 1.96094 11.5Z"
      fill="#A4A4A4"
    ></path>
  </svg>
);
